export const TrText = (props) => {
    const {text} = props
    return (
        <>
            <tr><td><div className="text-lg iPad/iPadMini:w-full w-full">{text}</div></td></tr>
        </>
    );
}